import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const MerchandisePrimaryButton = styled.button.attrs({
  className:
    "inline-flex items-center gap-2 rounded-2xl bg-[var(--brand-accent)] px-4 py-3 text-sm font-medium text-white transition hover:bg-[var(--brand-accent-deep)]",
})``;

export const MerchandiseInfoRow = styled.div.attrs({ className: "flex items-center gap-3" })``;

export const MerchandiseThumbnailImage = styled(FallbackImage).attrs({
  className: "h-12 w-12 rounded-2xl",
})``;

export const MerchandiseLabelText = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const MerchandiseMetaText = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;

export const MerchandiseGridLayout = styled.div.attrs({
  className: "grid gap-3 md:grid-cols-[1.4fr_0.8fr_0.8fr]",
})``;

export const MerchandiseFieldInput = styled.input.attrs({ className: "brand-input" })``;

export const MerchandiseFieldSelect = styled.select.attrs({ className: "brand-input" })``;
